<template>
    <div class="form-group -mx-2 flex flex-wrap">
        <label class="form-label w-3/12 px-2">
            <span>Wire Info.</span>
        </label>
        <div class="w-9/12 px-2">
            <div class="form-label p-0">
                <select
                    aria-label="Select wire instructions"
                    data-id="wireDoc_id"
                    name="wireDoc_id"
                ></select>
                <span
                    id="wireDoc_id_error"
                    class="form-control-error-description"
                    data-id="wireDoc_id.error"
                ></span>
                <!-- server error messages -->
            </div>
        </div>
    </div>

    <div
        v-if="showRecipients"
        id="wireDoc_recipients_block"
        class="form-group -mx-2 flex flex-wrap"
    >
        <label class="form-label w-3/12 px-2 pl-4">
            <span>Recipients</span>
        </label>
        <div class="w-9/12 px-2">
            <div class="form-label p-0">
                <select
                    aria-label="Select wireDoc recipients"
                    data-id="wireDoc_recipients"
                    multiple
                    name="wireDoc_recipients[]"
                ></select>
                <span
                    id="wireDoc_recipients_error"
                    class="text-ds-red-500"
                    data-id="wireDoc_recipients.error"
                ></span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    // recipients?: unknown;
    showRecipients?: boolean; // Added in anticipation of use with the Add File form
}>();
</script>
